/* eslint-disable no-console */
let debug = false

export function setDebug(value: boolean = false) {
  debug = value
}

export function debugLog(title: string, ...message: unknown[]) {
  if (debug) {
    console.log('YzcNotify debug:', title, ...message)
  }
}
